import { v4 as uuid } from "uuid";

export const mapUniqueIdsToList = <T>(list: T[]): T[] => list.map(c => ({ ...c, id: uuid(), error: "" }));
